// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios?noredirect=1&lq=1

// istanbul ignore next
function isIOS() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}

export { isIOS };
